import { useEffect, useRef } from 'react';

export function LiveRegion({ message, role = 'status' }) {
  const regionRef = useRef(null);

  useEffect(() => {
    if (regionRef.current && message) {
      const current = regionRef.current;
      current.textContent = '';
      setTimeout(() => {
        current.textContent = message;
      }, 100);
    }
  }, [message]);

  return (
    <div
      ref={regionRef}
      role={role}
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    />
  );
}
